module.exports = __webpack_public_path__ + "img/ic_tbf@2x.db243d9f.png";